interface CustomPeriodItemProps {
  title: string;
  onClick?: () => void;
}

export function CustomPeriodItem({ title, onClick }: CustomPeriodItemProps) {
  return (
    <span
      className="menu-item px-4 py-2 border-b-[1px] cursor-pointer hover:bg-gray-100"
      onClick={onClick}
    >
      {title}
    </span>
  );
}
